import React, { ComponentState, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getPendingDoc, saveSignedDocResponse } from "../../../../../redux/actions"
import { DocumentRequestObj, MetaData, ResultDocumentData } from "../../../../../dataModel/documentModels"
import moment from "moment"
import { DocumentListComponent } from "./documentListComponent"


export const PendingDocList = () => {

    const state: ComponentState = useSelector(states => {
        return states;
    });
    const { pendingDoc,saveSignedDocResp } = state['DocumentReducer'];
    const { loadingState } = state['LoaderReducer'];
    var now = new Date();
    var previous = new Date(moment(new Date()).subtract(5, 'years').format('YYYY-MM-DD'));
    const emptyObj: DocumentRequestObj = { startDate: previous, endDate: now, pageNumber: 1, pageSize: 10 }
    const [requestObj, setRequestObj] = useState<DocumentRequestObj>(emptyObj)
    const dispatch = useDispatch()
    const [pendingDocList, setPendingDocList] = useState<ResultDocumentData[]>()
    const [metaObj, setMetaObj] = useState<MetaData>()
    const [isDataFetched, setIsDataFetched] = useState(false)

    useEffect(() => {
        if (pendingDoc && pendingDoc.resultData) {
            setPendingDocList(pendingDoc.resultData)
            setMetaObj(pendingDoc.metaData)
        }
    }, [pendingDoc])


    useEffect(() => {
        if (saveSignedDocResp && saveSignedDocResp.status) {
            dispatch(saveSignedDocResponse())
            setRequestObj({...requestObj,pageNumber:1})
            dispatch(getPendingDoc({...requestObj,pageNumber:1}))
        }
    }, [saveSignedDocResp])

    


    useEffect(() => {
        if (!isDataFetched) {
            setIsDataFetched(true)
            dispatch(getPendingDoc(requestObj))
        }
    }, [loadingState])



    function handleChangePage(event: any, newpage: any) {
        setRequestObj({ ...requestObj, pageNumber: (newpage + 1) })
        dispatch(getPendingDoc({ ...requestObj, pageNumber: (newpage + 1) }))
    }

    function handleChangeRowsPerPage(event: any) {
        setRequestObj({ ...requestObj, pageSize: parseInt(event.target.value, 10), pageNumber: 1 })
        dispatch(getPendingDoc({ ...requestObj, pageSize: parseInt(event.target.value, 10), pageNumber: 1 }))
    }

    return (
        <DocumentListComponent
        tabSelecteionID="tabs-1"
        tabId={1}
        loadingState={loadingState}
        documentList={pendingDocList? pendingDocList:[]}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        metaObj={metaObj}
        requestObj={requestObj}
        ></DocumentListComponent>
    );
}